import React from 'react'
import { BsThreeDots } from 'react-icons/bs'
import { FiTrendingUp } from 'react-icons/fi'
import { HiUsers } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import CustomDropdown from '../../Components/CustomDropdown'
import styles from "../Leads/Styles/Leads.module.css"

export default function Projects() {
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
        <header>
        <p>30 Day Projects</p>

        <div className={styles.dropdownContainer}>
        <CustomDropdown value="Last 30 days" options={['one','two']} />
        </div>
      </header>

      <div className={styles.headerCards}>
        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#DAEEFF'}} className={styles.cardIcon}>
            <HiUsers color="#299EFE" size={20} />
            </div>
            <h2>New Projects</h2>
          </div>
            <h1>12</h1>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>In Progress</h2>
          </div>
            <h1>3</h1>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>On Hold</h2>
          </div>
            <h1>1</h1>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>Delivered</h2>
          </div>

            <h1>6</h1>
        </div>
      </div>


     <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
        <h2 style={{fontSize:24,fontWeight:500}}>All Projects</h2>
        <div className={styles.dropdownContainer}>
        <CustomDropdown value="Last 30 days" options={['one','two']} />
        </div>
     </div>

     <div className={styles.leads}>
     <table cellPadding={0} cellSpacing={0} className={styles.table}>
            <thead>
              <tr>
                <th>Project ID</th>
                <th>Full Name</th>
                <th>Project Stage</th>
                <th>Assigned To</th>
                <th>Added On</th>
                <th>Last Contacted</th>
                <th>Updated On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {Array(5).fill('').map(i => {
                return <tr onClick={()=>navigate('overview')}>
                <td style={{width:100}} className={styles.leadId}>45216</td>
                <td>Vishal Rawat</td>
                <td>Negative</td>
                <td>Nikita</td>
                <td>08 Nov</td>
                <td>11 Nov</td>
                <td>11 Nov ;02:40 PM</td>
                <td><BsThreeDots size={22} /></td>
              </tr>
              })}
            </tbody>
          </table>
     </div>
    </div>
  )
}
